<template>
  <div class="d-flex align-center flex-column pt-3">
    <div class="_60_w">
      <v-card flat class="pa-4">
        <div class="d-flex px-2 align-start mb-2">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="$router.go(-1)"
                icon
              >
                <v-icon color="#006341">mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h3 class="mx-2">Managing Alumni Regional</h3>
        </div>
      </v-card>

      <div class="mt-4">
        <v-row no-gutters align="center">
          <v-col cols="12" md="6">
            <v-text-field
              placeholder="Search"
              solo
              v-model="find"
              @keyup="fetchData"
              hide-details
              dense
              prepend-inner-icon="mdi-magnify"
              flat
              color="#006341"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex justify-end">
              <v-btn
                depressed
                color="var(--g)"
                to="/admin/msn/data-alumni"
                dark
                class="text-capitalize"
                >Assign Alumni</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="mt-3">
        <v-btn
          v-if="storage_id.length"
          depressed
          color="red"
          @click="unassignAlumni"
          dark
          class="text-capitalize stiki_btn"
        >
          <v-icon class="mr-2">mdi-close-circle-outline</v-icon>
          Remove from region
        </v-btn>
      </div>
      <div class="mt-3">
        <v-skeleton-loader
          class="my-5"
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading && dataSet">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
            :show-select="true"
            v-model="storage_id"
            :item-class="row_classes"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      depressed
                      fab
                      class="text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      :to="`/admin/msn/alumni/${item.scholar.user_id}/manage-profile-alumni`"
                    >
                      <v-icon dark small> mdi-cog </v-icon>
                    </v-btn>
                  </template>
                  <span>Manage User</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
        <div class="text-center my-2 pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
        <div
          class="empty d-flex align-center justify-center flex-column"
          v-if="!dataSet && !loading"
        >
          <img
            src="../../../assets/img/redaksi/pagenotfound.png"
            height="250px"
            alt=""
          />
          <b class="default_txt my-3">Data not found</b>
        </div>
      </div>
    </div>
    <div class="pa-2">
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        line="true"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "memberAlumniRegional",
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      d_large: false,
      d_small: false,
      hide_title: "",
      btnTitle: "",
      inventory: "",
      d_type: "",
      d_title: "",
      dataSet: null,
      page: 1,
      limit: 15,
      find: "",
      headers: [
        {
          text: "ID",
          align: "center",
          value: "id",
        },
        {
          text: "Name",
          value: "scholar.name",
          sortable: false,
        },
        {
          text: "Email",
          value: "scholar.email",
          sortable: false,
        },
        {
          text: "Phone",
          value: "scholar.wa_number",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      storage_id: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `support/alumni-region/alumni?page[number]=${this.page}&page[size]=${this.limit}&filter[name]=${this.find}&include=scholar&filter[scholar_alumni_region_id]=${this.$route.params.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    unassignAlumni() {
      let id = this.storage_id.map((el) => {
        return el.scholar_id;
      });
      this.inventory = id;
      this.d_type = "r_alumni";
      this.d_small = true;
    },
    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style scoped>
.stiki_btn {
  position: sticky;
}
</style>
